export class CategoryModule {
    gnCategoryID: number = 0;
    nameAr: string = '';
    nameEn: string = '';
    type: string = '';
    notes: string = '';
    isVisible: boolean = true;

 }
